import { baseApi } from '../../../core/data/rtk/baseQuery';
import { ApiResponseType } from '../../../core/data/rtk/apiResponseType';
import { SettingResponseType, Data } from '../types/settingResponse';
import { SettingPayloadType } from '../types/settingRequest';

export const settingApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllSettings: builder.query<ApiResponseType<Data>, { size?: number; search?: string, page?:number }>({
            query: (params) => {
                const queryParams = new URLSearchParams();
                if (params?.size) queryParams.append('size', params.size.toString());
                if (params?.search) queryParams.append('search', params.search);
                if (params?.page) queryParams.append('page', params.page.toString());
                
                return `settings/get-all?${queryParams.toString()}`;
            },
            providesTags: ['Settings'],
        }),
        addSetting: builder.mutation<ApiResponseType<{academicSetting: SettingResponseType}>, SettingPayloadType>({
            query: (payload) => ({
                url: 'settings/save',
                method: 'POST',
                body: payload
            }),
            invalidatesTags: ['Settings'],
        }),
        getSettingById: builder.query<ApiResponseType<{ setting: SettingResponseType }>, { id: string }>({
            query: ({ id }) => `settings/get/${id}`,
            providesTags: ['Settings'],
        }),
        updateSetting: builder.mutation<ApiResponseType<{ academicSetting: SettingResponseType }>, { id: string; payload: SettingPayloadType }>({
            query: ({ id, payload }) => ({
                url: `settings/update/${id}`,
                method: 'PUT',
                body: payload
            }),
            invalidatesTags: ['Settings'],
        }),
        deleteSetting: builder.mutation<ApiResponseType<{ deleted: true }>, { id: string }>({
            query: ({ id }) => ({
                url: `settings/delete/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: ['Settings'],
        }),
    }),
});

export const { 
    useGetAllSettingsQuery,
    useAddSettingMutation,
    useGetSettingByIdQuery,
    useUpdateSettingMutation,
    useDeleteSettingMutation
} = settingApi;